import React, { useEffect, useState } from 'react';
import { loadingState } from 'src/atom/LoadingState';
import { useLocation } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { globalStream } from 'src/atom/GlobalStream';
import { useNavigate } from 'react-router-dom';
import Tostify, { showToast } from 'src/utils/Tostify';
import { sendOTP } from 'src/services/Registration/RegisterationService';
import LogoHeader from 'src/components/header/LogoHeader';

const RegistrationDetails = () => {
  const [GSteam, setGlobalSteam] = useRecoilState(globalStream);
  const registrationObject = {
    counsellingName: `${GSteam.counsellingName}`,
    neetRollNumber: `${GSteam.neetRollNumber}`,
    email: `${GSteam.email}`,
    phoneNumber: `${GSteam.mobileNumber}`
  };
  const location = useLocation();
  const { neetRollNumber, email, phoneNumber, counsellingId } = location.state || {};
  const [formData, setFormData] = useState(registrationObject);
  const [errors, setErrors] = useState({});
  const [loader, enableLoader] = useRecoilState(loadingState);
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (neetRollNumber || email || phoneNumber || counsellingId) {
      setFormData({
        neetRollNumber: neetRollNumber || '',
        phoneNumber: phoneNumber || '',
        email: email || '',
        counsellingId: counsellingId || 1,
      });
    }
  }, [neetRollNumber, email, phoneNumber, counsellingId]);

  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[6-9]\d{9}$/;

    if (!formData.email || formData.email === "null") {
      newErrors.email = 'Email is required';
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if (!formData.phoneNumber || formData.phoneNumber === "null") {
      newErrors.phoneNumber = 'Mobile number is required';
    } else if (!phoneRegex.test(formData.phoneNumber)) {
      newErrors.phoneNumber = 'Please enter a valid 10-digit mobile number starting with 6-9';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const sendOtpAll = async () => {
    if (!validateForm()) {
      return;
    }
    enableLoader(true);
    const sendVerificationOTP = async () => {
      setIsSubmitting(true);
      enableLoader(true);
      const response = await sendOTP(formData);
      if (response.success) {
        setIsSubmitting(false);
        const id = response.body.id;
        navigate('/otp-screen', { state: { id } });
        enableLoader(false);
      } else {
        setIsSubmitting(false);
        enableLoader(false);
        showToast(response.message, 'error');
      }
    };
    sendVerificationOTP();
  };

  const handleSubmit = () => {
    sendOtpAll();
  };

  useEffect(() => {
    if (!formData.neetRollNumber) {
      navigate('/homepage');
    }
  }, [formData.neetRollNumber]);

  const maskedNumber = phoneNumber && phoneNumber !== "null"
    ? phoneNumber.slice(0, -2).replace(/./g, '*') + phoneNumber.slice(-2)
    : '';

  const maskedEmail = email && email !== "null"
    ? email.split('@')[0].slice(0, 3) + email.split('@')[0].slice(3).replace(/./g, '*') + '@' + email.split('@')[1]
    : '';

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' })); // Clear error on change
  };

  return (
    <>
      <div className="container-fluid" style={{ padding: '10px 20px' }}>
        <LogoHeader />
        <div
          className="mt-2 d-flex justify-content-center align-items-center"
          style={{ fontWeight: 'bold', fontSize: '25px' }}
        >
          Online Application Form For Admission To{' '}
          {GSteam.counsellingName === 'UG' ? 'BAMS/BHMS ' : 'MD/MS (Ayurveda) '} courses 2026-27
        </div>

        <div className="card ms-5 me-5 mt-3">
          <div className="card-body">
            <div className="row">
              <div className="col-12 d-flex justify-content-start">
                <th>Verification of Communication Details</th>
              </div>
            </div>
            <hr />
            <div className="row mt-2">
              <div className="col-sm-12">
                <div className="row">
                  <div className="col">
                    <label htmlFor="Email">Email:</label>
                    {email && email !== "null" ? (
                      <input
                        type="text"
                        className="form-control"
                        id="Email"
                        name="email"
                        value={maskedEmail}
                        disabled
                      />
                    ) : (
                      <>
                        <input
                          type="text"
                          className="form-control"
                          id="Email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          placeholder="Enter email"
                        />
                        {errors.email && <div className="text-danger">{errors.email}</div>}
                      </>
                    )}
                  </div>
                  <div className="col">
                    <label htmlFor="phoneNumber">Mobile Number:</label>
                    {phoneNumber && phoneNumber !== "null" ? (
                      <input
                        type="text"
                        className="form-control"
                        id="phoneNumber"
                        name="phoneNumber"
                        value={maskedNumber}
                        disabled
                      />
                    ) : (
                      <>
                        <input
                          type="text"
                          className="form-control"
                          id="phoneNumber"
                          name="phoneNumber"
                          value={formData.phoneNumber}
                          onChange={handleInputChange}
                          placeholder="Enter mobile number"
                        />
                        {errors.phoneNumber && <div className="text-danger">{errors.phoneNumber}</div>}
                      </>
                    )}
                  </div>
                </div>

                <div className="d-flex flex-column align-items-start mt-3">
                  <label style={{ color: 'red', lineHeight: '1.6' }}>
                    <div>
                      1. A separate One-Time Password (OTP) will be sent to your registered
                      email address and mobile number for verification.
                    </div>
                    <div>
                      2. Please enter the OTPs received on your email address and mobile number
                      to complete the verification process.
                    </div>
                  </label>
                </div>
                <hr />
                <div className="m-3 text-left form-group">
                  <button
                    type="submit"
                    className="btn btn-sm btn-success text-white"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Tostify />
    </>
  );
};

export default RegistrationDetails;